function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  // Helper function to check if media should be excluded from pausing
  const shouldSkipMedia = (element) => {
  // Skip videos inside product__media containers
  if (element.closest('.product__media')) return true;
  // Skip videos with data-no-pause attribute
  if (element.hasAttribute && element.hasAttribute('data-no-pause')) return true;
  return false;
  };

  document.querySelectorAll(".js-youtube").forEach((video) => {
    if (shouldSkipMedia(video)) return;
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}',"*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
  if (shouldSkipMedia(video)) return;
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => {
  if (shouldSkipMedia(video)) return;
    video.pause();
  });
  document.querySelectorAll("product-model").forEach((model) => {
  if (shouldSkipMedia(model)) return;
  if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      const templateContent = this.querySelector("template");
      if (!templateContent) return;
      
      const firstChild = templateContent.content.firstElementChild;
      const secondChild = firstChild.nextElementSibling;

      if (firstChild && window.innerWidth >= 600){
        content.appendChild(firstChild.cloneNode(true));        
      }
      else if (secondChild && window.innerWidth < 600){
        content.appendChild(secondChild.cloneNode(true));
      }
      else if (firstChild){
        content.appendChild(firstChild.cloneNode(true));
      }
      else {
        return;
      }


      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClickTop.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClickBottom.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    // if (
    //   this.isSlideVisible(this.sliderItemsToShow[0]) &&
    //   this.slider.scrollLeft === 0
    // ) {
    //   this.prevButton.setAttribute("disabled", "disabled");
    // } else {
    //   this.prevButton.removeAttribute("disabled");
    // }

    // if (
    //   this.isSlideVisible(
    //     this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
    //   )
    // ) {
    //   this.nextButton.setAttribute("disabled", "disabled");
    // } else {
    //   this.nextButton.removeAttribute("disabled");
    // }
  }

  isSlideVisible(element, offset = 0) {
    if (!element || !this.slider) return false;

    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  // onButtonClick(event) {
  //   event.preventDefault();
  //   const step = event.currentTarget.dataset.step || 1;
  //   this.slideScrollPosition =
  //     event.currentTarget.name === "next"
  //       ? this.slider.scrollLeft + step * this.sliderItemOffset
  //       : this.slider.scrollLeft - step * this.sliderItemOffset;
  //   this.setSlidePosition(this.slideScrollPosition);
  // }

  // setSlidePosition(position) {
  //   this.slider.scrollTo({
  //     left: position,
  //   });
  // }

  scrollThumbnailList(direction = 1) {
    const container = document.querySelector('.thumbnail-list');
    if (!container) return;

    const amount = 150; // píxeles que se mueve por click
    container.scrollTop += direction * amount;
  }

  onButtonClickTop() {
    this.scrollThumbnailList(-1);
  }

  onButtonClickBottom() {
    this.scrollThumbnailList(1);
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.observeSizesGuide();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.customButtonPrice();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    const quickAdd = this.closest('quick-add')
    if(quickAdd && this.currentVariant){
      quickAdd.currentVariantId = this.currentVariant.id
    }
  }

  isColorOptionName(name) {
    const optionName = String(name || "").toLowerCase();
    return (
      optionName === "color" ||
      optionName === "colour" ||
      optionName === "farbe" ||
      optionName === "couleur" ||
      optionName === "denominations"
    );
  }

  isSizeOptionName(name) {
    const optionName = String(name || "").toLowerCase();
    return (
      optionName.includes("fit") ||
      optionName.includes("size") ||
      optionName.includes("taille") ||
      optionName.includes("größe") ||
      optionName.includes("grosse")
    );
  }

  getSelectedSizeValue() {
    let fallback = "";
    let sizedValue = "";

    this.querySelectorAll("fieldset").forEach((fieldset) => {
      const input = fieldset.querySelector("input[name]");
      const checked = fieldset.querySelector("input:checked");
      if (!input || !checked) return;
      if (this.isColorOptionName(input.name)) return;
      if (this.isSizeOptionName(input.name)) {
        sizedValue = checked.value;
        return;
      }
      if (!fallback) fallback = checked.value;
    });

    if (sizedValue) return sizedValue;

    this.querySelectorAll("select").forEach((select) => {
      const name = select.name || "";
      if (this.isColorOptionName(name)) return;
      if (this.isSizeOptionName(name)) {
        sizedValue = select.value;
        return;
      }
      if (!fallback) fallback = select.value;
    });

    return sizedValue || fallback;
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const sizeValue = this.getSelectedSizeValue();
    const featuredMediaId = this.currentVariant.featured_media?.id;
    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );

    mediaGalleries.forEach((mediaGallery) => {
      if (featuredMediaId && typeof mediaGallery.setActiveMedia === "function") {
        mediaGallery.setActiveMedia(
          `${this.dataset.section}-${featuredMediaId}`,
          true
        );
      }
      if (typeof mediaGallery.filterGeneralImagesBySize === "function") {
        mediaGallery.filterGeneralImagesBySize(sizeValue);
      }
    });

    if(!mediaGalleries.length && this.dataset.masterSection){
      const masterMediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.masterSection}"]`)
      masterMediaGalleries.forEach((mediaGallery) => {
        if (featuredMediaId && typeof mediaGallery.setActiveMedia === "function") {
          mediaGallery.setActiveMedia(
            `${this.dataset.masterSection}-${featuredMediaId}`,
            true,
            true
          );
        }
        if (typeof mediaGallery.filterGeneralImagesBySize === "function") {
          mediaGallery.filterGeneralImagesBySize(sizeValue);
        }
      });
    }

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent || !featuredMediaId) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${featuredMediaId}"]`
    );
    if (newMediaModal) modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  sizesGuideGo() {
    const CONTAINERS = '.gfbVolumeDiscountLabelParentContainer, .gfbFrequentBoughtLabelParentContainer';
    const SELECTOR = 'modal-opener[data-modal*="PopupModal"]';

    const variableContainers = document.querySelectorAll(CONTAINERS);
    if (!variableContainers.length) return;

    if (!window.popUpBackup) {
      const original = document.querySelector(SELECTOR);
      if (!original) return;
      window.popUpBackup = original.cloneNode(true);
      original.remove();
    }

    variableContainers.forEach((container) => {
      if (container.nextElementSibling?.matches?.(SELECTOR)) return;

      const clone = window.popUpBackup.cloneNode(true);
      clone.style.display = 'block';
      clone.style.opacity = '0';
      clone.style.transition = 'opacity 0.3s ease';

      container.insertAdjacentElement('afterend', clone);

      const btn = clone.querySelector('.product-popup-modal__button');
      if (btn) {
        btn.style.opacity = '1';
        btn.style.marginTop = '1rem';
        btn.style.fontSize = '14px';
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          clone.style.opacity = '1';
        });
      });
    });
  }

  observeSizesGuide() {
    if (window.__sizesGuideObserver) return;

    console.log('window', window)
    console.log('window.__sizesGuideObserver', window.__sizesGuideObserver)

    let scheduled = false;
    window.__sizesGuideObserver = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        this.sizesGuideGo();
      });
    });

    window.__sizesGuideObserver.observe(document.body, { childList: true, subtree: true });
    this.sizesGuideGo();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const stickySource = html.getElementById(`sticky-atc`);

        const stickyDestination = document.getElementById('sticky-atc');

        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (stickySource && stickyDestination) {
          const currentSection = this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section;
          if (currentSection != "sticky-atc") {
            stickyDestination.querySelector('.sticky-atc__left').innerHTML =
              stickySource.querySelector('.sticky-atc__left').innerHTML;
            stickyDestination.reinitialize();
          }
          window.innerWidth > 990 &&
            (stickyDestination.querySelector('.sticky-atc__image').innerHTML =
              stickySource.querySelector('.sticky-atc__image').innerHTML);
          stickyDestination.querySelector('.sticky-atc__right').innerHTML =
            stickySource.querySelector('.sticky-atc__right').innerHTML;
        }

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination && inventorySource)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch((e) => console.error('renderProductInfo error:', e))
      .finally(() => {
        this.sizesGuideGo();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      //if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      //addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  // tagNewColors(){
  //   let tittle = document.getElementById('product__title_id');
  //   if(this.currentVariant.name == 'Go Neck Pillow - Green Moss' && window.location.href.includes('ostrichpillow.com')){
  //     let tagNewColor = document.createElement('span');
  //         tagNewColor.classList.add('tag-new-color');
  //         tagNewColor.innerText = 'New color';
  //         tittle.prepend(tagNewColor);
  //   }else{
  //     let tagNewColor = document.querySelector('.tag-new-color');
  //       if(tagNewColor){
  //         tagNewColor.remove();
  //       }
  //   }
  // }

  customButtonPrice(){
    const price = document.querySelector('.discounted-price-button');
    const priceDiscount = document.querySelector('.discounted-price-button .price-no-discount');
    if( price && this.currentVariant.compare_at_price){
      //price.innerHTML = '';
      price.innerText = (this.currentVariant.price/100).toFixed(2);
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const available = listOfAvailableOptions.includes(input.getAttribute("value"));
      input.classList.toggle("disabled", !available);
      const label =
        input.nextElementSibling?.tagName === "LABEL"
          ? input.nextElementSibling
          : this.querySelector(`label[for="${input.id}"]`);
      if (label) label.classList.toggle("disabled", !available);
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedInput = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      return checkedInput ? checkedInput.value : "";
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);


class CardProduct extends HTMLElement{
  constructor(){
    super()

    this.colorSwatches = this.querySelectorAll('.js-toggle-color-swatch')
    this.showMoreSwatches = this.querySelector('.color-swatch--more')
    this.variantsInfoSelect = this.querySelector('#CardProductVariants')
    this.variantsImages = this.querySelectorAll('.variant-image')
    this.productInfo = JSON.parse(this.querySelector('.card-product-info').textContent)
    this.numOptions = this.dataset.optionCount
    this.swatchesLength = this.colorSwatches.length
    this.productTitle = this.querySelector('.full-unstyled-link').textContent.replace(/\s+/g, "");
    this.quickAdd = this.querySelector('quick-add')

    if(this.numOptions == 1){
      this.colorSwatches.forEach(swatch=>{
        !this.checkAvailability(swatch.dataset.optionValue, null, null) ? swatch.classList.add('disabled') : swatch.classList.remove('disabled')
        !this.checkAvailability(swatch.dataset.optionValue, null, null) && this.swatchesLength--
      })
    }else{
      const activeSwatch = this.querySelector('.js-toggle-color-swatch.checked') || this.colorSwatches[0]
      if (activeSwatch) this.updateSizeOptions(activeSwatch)
    }

    //Hide show more swatches if there are no more options
    if(this.swatchesLength > 3){
      this.showMoreSwatches.innerHTML = `+${this.swatchesLength -3}`
    }else if(this.showMoreSwatches){
      this.showMoreSwatches.classList.add('hidden')
    }else{
      this.showMoreSwatches = null
    }

    this.colorSwatches.forEach((swatch, index)=>{
      if(index > 2){
        swatch.classList.add('hidden')
      }
    })

    //Show swatches wrapper
    this.classList.remove('color-swatches--hidden')

    this.showMoreSwatches && this.showMoreSwatches.addEventListener('click', ()=>{
      this.showMoreSwatches.classList.add('hidden')
      this.colorSwatches.forEach(swatch=>swatch.classList.remove('hidden'))
    })

    this.colorSwatches.forEach(swatch=>{
      swatch.addEventListener("click", (e)=>{
        e.preventDefault()
        this.colorSwatches.forEach(sw=>sw.classList.remove("checked"))
        swatch.classList.add("checked")
        this.toggleQuickAdd(swatch)
        if(this.numOptions > 1){
          this.updateSizeOptions(swatch)
        }
        this.syncSelectedVariant()
      })
    })

    this.quickAdd?.addEventListener("change", () => {
      this.syncSelectedVariant()
    })

    //Gallery arrows: secondary media is only downloaded when the user navigates
    this.container = this.querySelectorAll('.card--media');
    this.container.forEach(element => {
      let arrowLeft = this.querySelector('.arrow-left');
      let arrowRight = this.querySelector('.arrow-right');
      const images = [
        ...this.querySelectorAll('.img-media-arrow-card'),
        ...this.querySelectorAll('.media-product-gallery video')
      ];
      if (!arrowLeft || !arrowRight || !images.length) return;

      const activeIndex = images.findIndex((image) => image.classList.contains('active'));
      let currentImageIndex = activeIndex > -1 ? activeIndex : 0;

      const goTo = (direction) => {
        const total = images.length;
        const nextIndex = (currentImageIndex + direction + total) % total;

        //Load the media that is about to be shown
        this.loadMedia(images[nextIndex]);
        //Preload the following one in the same direction
        this.loadMedia(images[(nextIndex + direction + total) % total]);

        this.variantsImages.forEach(image => image.classList.add('hidden'));
        images[currentImageIndex].classList.remove('active');
        currentImageIndex = nextIndex;
        images[currentImageIndex].classList.add('active');
      };

      arrowLeft.addEventListener('click', () => goTo(-1));
      arrowRight.addEventListener('click', () => goTo(1));
    });
  }

  loadMedia(el){
    if (!el) return

    if (el.tagName === 'IMG' && el.dataset.src) {
      if (el.dataset.srcset) el.srcset = el.dataset.srcset
      el.src = el.dataset.src
      el.removeAttribute('data-src')
      el.removeAttribute('data-srcset')
      return
    }

    if (el.tagName === 'VIDEO' && el.getAttribute('preload') === 'none') {
      el.setAttribute('preload', 'auto')
      el.autoplay = true
      el.load()
    }
  }

  getSelectedOptions(){
    const fieldsets = Array.from(this.querySelectorAll('quick-add fieldset'))
    if (fieldsets.length) {
      return fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value || null)
    }

    const colorValue = this.querySelector('.js-toggle-color-swatch.checked')?.dataset.optionValue
    return colorValue ? [colorValue] : []
  }

  findMatchingVariant(options = this.getSelectedOptions()){
    if (!options.length) return null

    return this.productInfo.find((variant) => {
      return options.every((value, index) => {
        if (value == null || value === '') return true
        return variant[`option${index + 1}`] === value
      })
    }) || null
  }

  syncSelectedVariant(){
    const variant = this.findMatchingVariant()
    if (!variant) return

    this.showVariantImage(variant.id)
    this.updateCardLinks(variant.id)

    if (this.quickAdd) {
      this.quickAdd.currentVariantId = variant.id
    }
  }

  showVariantImage(variantId){
    this.querySelectorAll('.img-media-arrow-card').forEach((image) => image.classList.remove('active'))
    this.variantsImages.forEach((image) => image.classList.add('hidden'))
    const variantImage = this.querySelector(`.variant-image[data-variant-id="${variantId}"]`)
    if (variantImage) variantImage.classList.remove('hidden')
  }

  updateCardLinks(variantId){
    const mediaLink = this.querySelector('.card__media')
    const contentLink = this.querySelector('.card__content')
    if (!mediaLink) return

    let newLink = mediaLink.getAttribute('href') || ''
    if (!newLink.includes('?')) {
      newLink += `?variant=${variantId}`
    } else if (newLink.includes('variant=')) {
      newLink = newLink.replace(/variant=\d+/g, `variant=${variantId}`)
    } else {
      newLink += `&variant=${variantId}`
    }

    mediaLink.setAttribute('href', newLink)
    if (contentLink) contentLink.setAttribute('href', newLink)
  }

  updateSizeOptions(swatch){
    const colorValue = swatch.dataset.optionValue
    const sizeOptions = Array.from(this.querySelectorAll('quick-add input[type="radio"]')).filter((input) => {
      const name = String(input.name || "").toLowerCase()
      return name !== "color" && name !== "colour" && name !== "farbe" && name !== "couleur"
    })

    sizeOptions.forEach((option) => {
      const label = this.querySelector(`label[for="${option.id}"]`)
      if (!label) return

      const available = this.isColorSizeAvailable(colorValue, option.value)
      label.classList.toggle("disabled", !available)
      option.classList.toggle("disabled", !available)
    })

    const checkedOption = sizeOptions.find((option) => option.checked)
    if (checkedOption?.classList.contains("disabled")) {
      const firstAvailable = sizeOptions.find((option) => !option.classList.contains("disabled"))
      if (firstAvailable) {
        firstAvailable.checked = true
        firstAvailable.dispatchEvent(new Event("change", { bubbles: true }))
      }
    }
  }

  isColorSizeAvailable(colorValue, sizeValue){
    return this.productInfo.some((variant) => {
      if (!variant.available) return false
      const options = [variant.option1, variant.option2, variant.option3].filter((value) => value != null && value !== "")
      return options.includes(colorValue) && options.includes(sizeValue)
    })
  }

  toggleQuickAdd(swatch){
    const optionValue = swatch.dataset.optionValue
    const relatedQuickAddInput = this.querySelector(`quick-add input[name="Color"][value="${optionValue}"]`)
    if (relatedQuickAddInput) {
      relatedQuickAddInput.checked = true
      relatedQuickAddInput.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  checkAvailability(option1, option2, option3){
    var available = false
    this.productInfo.forEach(variant=>{
      if(option1 == variant.option1 && option2 == variant.option2 && option3 == variant.option3){
        available = variant.available
        return
      }
    })
    return available
  }

}

customElements.define("card-product", CardProduct)

class CollectionTogglers extends HTMLElement{
  constructor(){
    super()


    this.togglers = this.querySelectorAll('.js-toggle-featured-collection')
    this.togglersDescription = this.querySelectorAll('.text__description')
    this.collections = this.closest('.collection').querySelectorAll('.collection__wrapper')

    this.togglers.forEach((toggler) => {
      toggler.addEventListener("click", () => {
      this.toggleItems(toggler);
        this.togglersDescription.forEach((togglerDesc) => {
          togglerDesc.style.display = 'none';
          togglerDesc.classList.remove("active");
          if (togglerDesc.dataset.id === toggler.dataset.id) {
            togglerDesc.classList.add("active");
          }
        });
      });
    });
  }

  toggleItems(toggler){
    this.togglers.forEach(item=>item.classList.remove("active"))
    this.collections.forEach(collection=>collection.classList.add("collection__wrapper--hidden"))
    toggler.classList.add("active")
    document.querySelector(`#${toggler.dataset.id}`).classList.remove("collection__wrapper--hidden")
  }
}

customElements.define("collection-togglers", CollectionTogglers)